<template>
  <v-container>
    <v-row>
      <v-col class="pl-0">
        <v-menu
          v-model="dateMenu"
          :close-on-content-click="false"
          :return-value.sync="dateMenu"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              :value="formatDate(date)"
              :label="(textPrefix !== null) ? textPrefix + ' - ' + $t('common.date').toLowerCase() : $t('common.date')"
              readonly
              v-bind="attrs"
              v-on="on"
              :clearable="clerable"
              v-on:click:clear="clearDate()"
              :error-messages="errorMessages"
              :rounded="rounded"
              :disabled="disabled"
            ></v-text-field>
          </template>
          <v-date-picker v-if="!readonly" v-model="date"
                         type="date"
                         :max="getMax()"
                         no-title
                         scrollable
                         :first-day-of-week="1"
                         :locale="getIsoLocale()"
                         @input="dateMenu = false"
          >
          </v-date-picker>
        </v-menu>
      </v-col>

      <v-col class="pr-0">
        <v-menu
          ref="timeMenu"
          v-model="timeMenu"
          :close-on-content-click="false"
          :return-value.sync="timeMenu"
          transition="scale-transition"
          offset-y
          max-width="290px"
          min-width="auto"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
              v-model="time"
              :label="(textPrefix !== null) ? textPrefix + ' - ' + $t('common.time').toLowerCase() : $t('common.time')"
              :error-messages="errorMessages"
              readonly
              :clearable="clerable"
              v-on:click:clear="clearTime()"
              v-bind="attrs"
              v-on="on"
              :disabled="disabled"
              :rounded="rounded"
            ></v-text-field>
          </template>
          <v-time-picker
            v-if="!readonly"
            ref="oneDateTime"
            v-model="time"
            format="24hr"
            scrollable
            @click:minute="$refs.timeMenu.save(time)"
          >
          </v-time-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
/*
 * model input value format:
 * {
 *    date: "2022-10-10"
 *    time: "10:12"
 * }
 */
import { DateTime } from "luxon";
import i18n from "@/plugins/i18n";
import { DateTimeValue } from "@/dateTimeValue";

export default {
  name: "DateTimeField",

  props: {
    value: {
      type: Object
    },
    textPrefix: {
      type: String,
      default: null
    },
    max: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    clerable: {
      type: Boolean,
      default: false
    },
    rounded: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    errorMessages: {
      type: Array,
      default: () => []
    }

  },
  data() {
    return {
      dateMenu: false,
      timeMenu: false,
      date: null,
      time: null
    };
  },
  methods: {
    getIsoLocale() {
      return i18n.messages[i18n.locale].lang.iso;
    },

    emitValue() {
      if (this.disableEmit)
        return;

      this.$emit("input", new DateTimeValue(this.date, this.time));
    },

    getMax() {
      if (this.max === null)
        return undefined;
      else if (this.max === "current")
        return DateTime.now().startOf("day").plus({ days: 1 }).toISO();
      else
        return this.max;
    },

    clearDate() {
      this.date = null;
    },

    clearTime() {
      this.time = null;
    },

    setValue(value, emit = true) {
      value = value || new DateTimeValue();

      if (this.date !== (value.date || null)
        || this.time !== (value.time || null)) {
        this.disableEmit = true;
        this.$nextTick().then(() => {
          this.date = value.date || null;
          this.time = value.time || null;

          this.$nextTick().then(() => {
            this.disableEmit = false;
            if (emit)
              this.emitValue();
          });
        });
      }
    },

    formatDate(date) {
      if (date === null)
        return null;

      return DateTime.fromISO(date).toLocaleString(DateTime.DATE_SHORT);
    }
  },

  watch: {
    value: function() {
      this.setValue(this.value, true);
    },

    date: function() {
      this.emitValue();
    },

    time: function() {
      this.emitValue();
    }
  },

  mounted() {
    this.setValue(this.value);
  }
};
</script>

<style scoped>

</style>